export default __webpack_public_path__ + "static/media/sensotrend_uploader_forgotten_password.09fb5aa6.png";